// extracted by mini-css-extract-plugin
export default {"categories":"categories__HtYNzn6_"};